<template>
    <div class="content-body tenant-settings">
        <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="listTenants()">
            <el-form-item label="租户编码:">
                <el-input size="small" v-model="dataForm.code" placeholder="租户编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="租户名称:">
                <el-input size="small" v-model="dataForm.name" placeholder="租户名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="listTenants()" icon="el-icon-search">查询
                </el-button>
                <el-button size="small" type="primary" @click="addOrUpdateHandle()"
                           icon="el-icon-plus">新增
                </el-button>
                <el-button size="small" type="danger" @click="deleteHandle()"
                           :disabled="dataListSelections.length <= 0" icon="el-icon-delete">批量删除
                </el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                v-loading="dataListLoading"
                size="small"
                stripe
                @selection-change="selectionChangeHandle"
                :height="documentClientHeight"
                style="width: 100%;">
            <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="50">
            </el-table-column>
            <el-table-column
                    type="index"
                    width="50"
                    label="序号">
            </el-table-column>
            <el-table-column
                    prop="tenantCode"
                    header-align="left"
                    align="left"
                    label="租户编码">
            </el-table-column>
            <el-table-column
                    prop="tenantName"
                    header-align="left"
                    align="left"
                    label="租户名称">
            </el-table-column>
            <el-table-column
                    header-align="left"
                    align="left"
                    width="300"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small"
                               @click="menuUpdateHandle(scope.row.id)" icon="el-icon-menu">
                        分配授权用例
                    </el-button>
                    <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)" icon="el-icon-edit">修改
                    </el-button>
                    <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                :total="totalPage"
                layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="listTenants"></add-or-update>
        <menu-update v-if="menuUpdateVisible" ref="menuUpdate"></menu-update>
    </div>
</template>

<script>
    import {fetchTenantList, batchDeleteTenants} from '@/controller/sys'
    import AddOrUpdate from './tenant-add-or-update'
    import MenuUpdate from './menu-update'

    export default {
        data() {
            return {
                documentClientHeight: document.documentElement['clientHeight'] - 220,
                dataForm: {
                    code: '',
                    name: ''
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                menuUpdateVisible: false
            }
        },
        components: {
            AddOrUpdate,
            MenuUpdate
        },
        activated() {
            this.listTenants()
        },
        methods: {
            // 获取数据列表
            listTenants() {
                this.dataListLoading = true
                fetchTenantList(
                    {
                        'pageNo': this.pageIndex,
                        'pageSize': this.pageSize,
                        'tenantCode': this.dataForm.code,
                        'tenantName': this.dataForm.name
                    }
                ).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.listTenants()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.listTenants()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增 / 修改
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id)
                })
            },
            menuUpdateHandle(id) {
                this.menuUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.menuUpdate.init(id)
                })
            },
            // 删除
            deleteHandle(id) {
                let ids = id ? [id] : this.dataListSelections.map(item => {
                    return item.id
                })
                this.$confirm(`确定进行${id ? '删除' : '批量删除'}操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    batchDeleteTenants(ids).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.listTenants()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                })
            }
        }
    }
</script>